import React from "react";

import { Navigate } from 'react-router-dom'

export function RouteTurma({children}) {

    if(JSON.parse(sessionStorage.getItem('user')) == null){
        return <Navigate to="/"/>
    }

    const user = JSON.parse(sessionStorage.getItem('user'))[0]

    const decicion = user.tipouser >= 3 && user.tipouser <= 5 ? true : false
    return decicion ? children : <Navigate to="/"/>
}